<div class="stops-track">
  @for (s of stops(); track $index) {
    <span class="stop" [class]="s"></span>
  }
</div>
